import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {SalesSummarySelectors} from '../store/selectors';
import {OrdersActions} from '../store';

@Injectable()
export class SalesSummaryLoadedGuard implements CanActivate {

  constructor(private store$: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.loadSalesSummaryDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadSalesSummaryDone(): Observable<boolean> {
    return this.store$.pipe(
      select(SalesSummarySelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store$.dispatch(OrdersActions.ReadSalesSummary({}));
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
